import React from 'react';

export default function StaticPreview({
  data,
  size = 'sm'
}) {


  const frameClass =
    size === 'sm'
      ? 'phone-frame-sm'
      : 'phone-frame-lg';



  const bg =
    data?.palette?.bg ||
    '#f3ede7';


  const text =
    data?.palette?.text ||
    '#2b1e20';



  return (

    <div
      className={`
        phone-frame
        ${frameClass}
        mx-auto
      `}
    >

      <div
        className="
          phone-screen
          overflow-hidden
        "
      >


        <div

          className="
          w-full
          h-full
          overflow-y-auto
          scrollbar-hide
          flex
          flex-col
          items-center
          text-center
          "

          style={{
            background:bg,
            color:text
          }}

        >



          {
            data?.image &&
            (

            <img

              src={data.image}

              alt={
                data?.name ||
                'Invito'
              }

              className="
              w-full
              h-44
              object-cover
              "

            />

            )
          }




          <div

            className="
            flex
            flex-col
            justify-center
            items-center
            px-5
            py-8
            gap-3
            "

          >


            <div

              className="
              text-xs
              uppercase
              tracking-[0.3em]
              opacity-70
              "

            >

              INVITO

            </div>



            <h2

              className="
              font-serif
              text-2xl
              leading-tight
              "

            >

              {
                data?.celebrant ||
                data?.name ||
                'Nome'
              }


            </h2>




            {
              data?.event_name &&
              (

              <p

                className="
                italic
                text-base
                "

              >

                {data.event_name}

              </p>

              )
            }



            <div

              className="
              mt-4
              space-y-2
              text-xs
              opacity-80
              "

            >


              {
                data?.date &&
                (

                <div>
                  📅 {new Date(
                    data.date
                  ).toLocaleDateString(
                    'it-IT'
                  )}
                </div>

                )
              }




              {
                data?.time &&
                (

                <div>
                  🕒 {data.time}
                </div>

                )
              }




              {
                data?.location &&
                (

                <div>
                  📍 {data.location}
                </div>

                )
              }



            </div>




            {
              data?.message &&
              (

              <p

                className="
                font-serif
                text-sm
                mt-5
                px-2
                "

              >

                {data.message}

              </p>

              )
            }



          </div>



        </div>


      </div>


    </div>


  );

}
